import { listUsers } from './index';

import { usersRouteStore } from '../domain/store';

export default (e) => {
  usersRouteStore.setValue('filterValue', e.target.value);
  usersRouteStore.setValue('currentPage', 1);
  return listUsers();
};
